import { render } from "./Invitations.vue?vue&type=template&id=6656b280&scoped=true"
import script from "./Invitations.vue?vue&type=script&lang=js"
export * from "./Invitations.vue?vue&type=script&lang=js"

import "./Invitations.vue?vue&type=style&index=0&id=6656b280&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6656b280"]])

export default __exports__